<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="mode === 'list'">
      <v-toolbar :dense="true" >
        <v-toolbar-title class="body-2"> <v-icon>mdi-view-list</v-icon> Reserves </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-data-table :headers="reserveColumns" :items="reserves" :items-per-page="5" class="elevation-1">
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.clmtNo }}</td>
            <td>{{ row.item.clmItem }}</td>
            <td>{{ row.item.clmResCat }}</td>
            <td>{{ row.item.status }}</td>
            <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
            <td>{{ row.item.acctMth }}</td>
            <td>{{ row.item.acctYr }}</td>
            <td class="text-right">{{ row.item.reserve }}</td>
            <td class="text-right">{{ row.item.reserveLoc }}</td>
            <td>{{ formatDateTime2(row.item.entryDate) }}</td>
            <td>{{ row.item.userName }}</td>
          </tr></template
        >
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
export default {
  props: {},
  data() {
    return {
      loading: false,
      mode: 'list',
      reserveColumns: [
        { text: 'Clmt No', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'Payt Catg', align: 'left', value: 'clmResCat' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        { text: 'Acct Month', align: 'left', value: 'acctMth' },
        { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'Reserve Amount', align: 'right', value: 'reserve' },
        { text: 'Reserve Amount Local', align: 'right', value: 'reserveLoc' },
        { text: 'Entry Date', align: 'left', value: 'entryDate' },
        { text: 'User ID', align: 'left', value: 'userId' }
      ]
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    reserves() {
      return this.commonInfo.clmReses
    }
  },
  methods: {
    doClose() {
      this.$emit('close')
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
